<template>
  <div id="content-container" v-if="item">
    <div class="panel">
      <el-page-header @back="$router.go(-1)" content="调拨详情">
      </el-page-header>
      <el-descriptions
        title=""
        size="small"
        border
        :column="2"
        :contentStyle="{ 'max-width': '400px', 'min-width': '200px' }"
      >
        <el-descriptions-item label="单号"
          >{{ item.order_number
          }}<el-tag size="mini" class="ml-10"
            ><ItemStatus
              :status="item.category"
              model="supplyCategory"
            ></ItemStatus></el-tag
        ></el-descriptions-item>
        <el-descriptions-item label="状态">
          <ItemStatus :status="item.status" model="supply"></ItemStatus>
        </el-descriptions-item>
        <el-descriptions-item label="发起地">{{
          item.well.well_number || item.base.name
        }}</el-descriptions-item>
        <el-descriptions-item label="发出时间">
          {{ item.send_date }}
        </el-descriptions-item>
        <el-descriptions-item label="发货方式">
          <ItemStatus
            :status="item.delivery_category"
            model="supplyDelivery"
          ></ItemStatus>
        </el-descriptions-item>
        <el-descriptions-item label="创建人">{{
          item.user.name
        }}</el-descriptions-item>
        <el-descriptions-item label="提交时间" v-if="item.status > 1">
          {{ $time(item.created_at).format('YYYY-MM-DD HH:mm') }}
        </el-descriptions-item>
        <el-descriptions-item label="备注">
          {{ item.remark }}
        </el-descriptions-item>
        <el-descriptions-item label="附件">
          <div
            v-for="(item, index) in item.attachments"
            :key="item.name + index"
          >
            <el-link
              @click="handleDownload(item)"
              type="primary"
              class="font-12"
              >{{ item.name }}</el-link
            >
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="接收地">{{
          item.receive_well.well_number || item.approve_base.name
        }}</el-descriptions-item>
        <template v-if="[3, 4].includes(item.status)">
          <el-descriptions-item label="接收人">
            {{ item.approver.name }}
          </el-descriptions-item>
          <el-descriptions-item label="接收时间">
            {{ $time(item.approve_time).format('YYYY-MM-DD HH:mm') }}
          </el-descriptions-item>
          <el-descriptions-item label="拒收原因">
            {{ item.approve_remark || '' }}
          </el-descriptions-item>
        </template>
      </el-descriptions>
      <div class="mt-30 item-list">
        <span class="font-16 text-default"
          >物资明细（共 {{ item.items.length }} 件）</span
        >
        <div
          v-if="
            [1, 3].includes(item.entity_type) &&
            [2, 5].includes(item.status) &&
            item.approve_base_id == $store.state.userInfo.base_id
          "
        >
          <el-popconfirm
            title="确认全部（已单独拒收的除外）接收吗？"
            @confirm="hanldeApplyOption(true)"
            v-permission="Auth.supplyReceive"
          >
            <el-button type="primary" slot="reference" size="mini" plain
              >全部接收</el-button
            >
          </el-popconfirm>
          <el-button
            type="danger"
            size="mini"
            class="ml-10"
            plain
            v-permission="Auth.supplyReject"
            @click="hanldeApplyOption(false)"
            >全部拒收{{
          }}</el-button>
        </div>
      </div>

      <el-table border :data="item.items" size="mini">
        <el-table-column label="序号" type="index" width="50" align="center" />
        <el-table-column label="类型" width="150" align="center">
          <template slot-scope="scope">
            {{ ApplyItemCategoryMap[scope.row.category] }}
          </template>
        </el-table-column>
        <el-table-column label="物资名称" align="center">
          <template slot-scope="scope">
            {{
              scope.row.category == 3
                ? scope.row.product.name
                : scope.row.item.name
            }}
          </template>
        </el-table-column>
        <el-table-column label="物资编号" align="center">
          <template slot-scope="scope">
            <ProductDialog
              v-if="scope.row.category == 3"
              :model="scope.row.product"
              >{{ scope.row.product.code }}</ProductDialog
            >
            <ItemLink :model="scope.row.item" v-else>
              {{ scope.row.item.code }}
            </ItemLink>
          </template>
        </el-table-column>
        <el-table-column label="规格型号" align="center">
          <template slot-scope="scope">{{
            scope.row.category == 3
              ? getProductCustomParam(
                  scope.row.product.custom_params,
                  ['规格型号', '规格', '型号'],
                  scope.row.product_template,
                )
              : scope.row.item.model_number
          }}</template>
        </el-table-column>
        <el-table-column label="销售地" align="center">
          <template slot-scope="scope">{{
            getProductCustomParam(
              scope.row.category == 3
                ? scope.row.product.custom_params
                : scope.row.item.custom_params,
              ['销售地'],
            )
          }}</template>
        </el-table-column>
        <el-table-column label="特性1" align="center">
          <template slot-scope="scope">{{
            getProductCustomParam(
              scope.row.category == 3
                ? scope.row.product.custom_params
                : scope.row.item.custom_params,
              ['特性1'],
            )
          }}</template>
        </el-table-column>
        <template v-if="item.category == 2">
          <el-table-column label="工作时长" align="center" prop="used_date">
          </el-table-column>
          <el-table-column label="返厂原因" align="center" prop="return_reason">
          </el-table-column>
        </template>
        <el-table-column label="备注" align="center" prop="remark">
        </el-table-column>
        <el-table-column label="数量" align="center" prop="number">
          <template slot-scope="scope">
            {{ scope.row.number || 1 }}
          </template>
        </el-table-column>
        <el-table-column label="状态" align="center" v-if="item.status > 1">
          <template slot-scope="scope">
            <ItemStatus :status="scope.row.status" model="supply"></ItemStatus>
            <span v-if="scope.row.reject_reason"
              >（{{ scope.row.reject_reason }}）</span
            >
          </template>
        </el-table-column>

        <el-table-column
          label="操作"
          width="150"
          align="center"
          v-if="
            [5].includes(item.status) &&
            item.user_id == $store.state.userInfo.id
          "
        >
          <template slot-scope="scope">
            <el-popconfirm
              v-if="scope.row.status == 2"
              title="确认撤回该物资吗？"
              v-permission="Auth.supplyRecall"
              @confirm="handleItemOption(scope.row, true, true)"
            >
              <el-button
                slot="reference"
                type="text"
                size="small"
                class="text-danger"
                >撤回</el-button
              >
            </el-popconfirm>
          </template>
        </el-table-column>

        <el-table-column
          label="操作"
          width="150"
          align="center"
          v-if="
            [1, 3].includes(item.entity_type) &&
            [2, 5].includes(item.status) &&
            item.approve_base_id == $store.state.userInfo.base_id
          "
        >
          <template slot-scope="scope">
            <div v-if="scope.row.status == 2">
              <el-popconfirm
                title="确认接收吗？"
                v-permission="Auth.supplyReceive"
                @confirm="handleItemOption(scope.row, true)"
              >
                <el-button slot="reference" type="text" size="small"
                  >接收</el-button
                >
              </el-popconfirm>
              <el-button
                v-permission="Auth.supplyReject"
                @click="handleItemOption(scope.row, false)"
                type="text"
                size="small"
                class="text-danger"
                >拒收</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { applyDetail, applyOption, applyItemOption } from '@/service/getData'
import { ApplyItemCategoryMap } from '@/config/global'
import ItemSelect from '../../components/select/item_multiple_select.vue'

export default {
  components: {
    ItemSelect,
  },
  data() {
    return {
      ApplyItemCategoryMap,
      item: null,
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      let res = await applyDetail({
        id: this.$route.params.id,
      })
      if (res.status != 0) return
      this.item = res.data
    },

    async hanldeApplyOption(isPass = false) {
      let data = {
        id: this.item.id,
        pass: isPass,
      }

      if (isPass) {
        this.itemOption(data, false)
        return
      }

      this.$prompt('拒收原因', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputType: 'textarea',
        inputValidator: (value) => {
          return !!value
        },
        inputErrorMessage: '拒收原因不能为空',
      }).then(({ value }) => {
        data.remark = value
        this.itemOption(data, false)
      })
    },

    async itemOption(data, isItemOption = true) {
      let res
      if (isItemOption) {
        res = await applyItemOption(data)
      } else {
        res = await applyOption(data)
      }
      if (res.code == 0) {
        this.getData()
      }
    },

    //拒收
    handleItemOption(item, isPass = false, isRecall = false) {
      let data = {
        id: item.id,
        pass: isPass,
        recall: isRecall,
      }
      if (isPass) {
        this.itemOption(data)
        return
      }

      this.$prompt('拒收原因', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputType: 'textarea',
        inputValidator: (value) => {
          return !!value
        },
        inputErrorMessage: '拒收原因不能为空',
      }).then(({ value }) => {
        data.remark = value
        this.itemOption(data)
      })
    },

    handleDownload(file) {
      const x = new window.XMLHttpRequest()
      x.open('GET', file.url, true)
      x.responseType = 'blob'
      x.onload = () => {
        const url = window.URL.createObjectURL(x.response)
        const a = document.createElement('a')
        a.href = url
        a.download = file.name
        a.click()
      }
      x.send()
    },

    getProductCustomParam(params = [], label = [], template = {}) {
      if (label[0] == '规格型号' && template.custom_params) {
        let modelAliasParam = template.custom_params.find(
          (param) => param.model_alias,
        )
        if (modelAliasParam) {
          label = [modelAliasParam.label]
        }
      }
      const p = params.filter((item) => label.includes(item.label))[0]
      return p ? p.value : ''
    },
  },
}
</script>

<style scoped>
.item-list {
  font-size: 15px;
  color: #303133;
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}
</style>